export const categories = [
  {
    slug: "history",
    name: "历史",
    en: "History",
    icon: "ri-history-line",
    description:
      "追溯跨越大陆与世纪的黑人历史脉络，从古代文明、跨大西洋迁徙到民权运动，还原被时间掩埋的记忆与贡献。",
    keywords: "黑人历史,非裔历史,民权运动,非洲文明",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20sepia%20toned%20archival%20abstract%20collage%20of%20old%20maps%20and%20documents%2C%20vintage%20textured%20paper%20layers%2C%20museum%20archival%20aesthetic%2C%20soft%20natural%20light%2C%20muted%20earth%20tones%2C%20editorial%20photography&width=800&height=600&seq=cat-history-01&orientation=landscape",
  },
  {
    slug: "music",
    name: "音乐",
    en: "Music",
    icon: "ri-music-2-line",
    description:
      "从蓝调、爵士、灵魂乐到嘻哈，黑人音乐始终是世界流行文化的脉搏。这里记录声音背后的社会史与创造力。",
    keywords: "黑人音乐,爵士乐,蓝调,灵魂乐,嘻哈",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20sound%20waves%20and%20vintage%20brass%20trumpet%20silhouette%2C%20cozy%20studio%20lighting%2C%20rich%20brown%20and%20orange%20tones%2C%20artistic%20minimal%20composition%2C%20editorial%20photography&width=800&height=600&seq=cat-music-01&orientation=landscape",
  },
  {
    slug: "film",
    name: "影视",
    en: "Film",
    icon: "ri-film-line",
    description:
      "镜头是另一种历史书写。关注黑人导演、演员与银幕形象，观察影像如何改变叙事权与大众想象。",
    keywords: "黑人影视,非裔导演,黑人电影,银幕形象",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20vintage%20cinema%20projector%20light%20beams%20and%20film%20reels%2C%20warm%20dark%20room%20with%20amber%20glow%2C%20artistic%20moody%20composition%2C%20rich%20brown%20tones%2C%20editorial%20photography&width=800&height=600&seq=cat-film-01&orientation=landscape",
  },
  {
    slug: "art",
    name: "艺术",
    en: "Art",
    icon: "ri-palette-line",
    description:
      "绘画、雕塑、纺织与装置，非裔艺术家以视觉语言回应身份、记忆与权力，持续拓展当代艺术的边界。",
    keywords: "黑人艺术,非裔艺术家,当代艺术,身份表达",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20colorful%20paint%20palette%20and%20brushes%20on%20textured%20canvas%2C%20warm%20earthy%20tones%20with%20orange%20accents%2C%20art%20studio%20soft%20light%2C%20artistic%20composition%2C%20editorial%20photography&width=800&height=600&seq=cat-art-01&orientation=landscape",
  },
  {
    slug: "society",
    name: "社会动态",
    en: "Society",
    icon: "ri-group-line",
    description:
      "教育、社区、语言与公共议题，记录当代黑人社会面对的现实挑战与不断生长的行动力量。",
    keywords: "黑人社会,社区,公共议题,社会动态",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20community%20gathering%20silhouettes%20at%20golden%20hour%2C%20soft%20orange%20and%20brown%20gradient%20light%2C%20hopeful%20atmosphere%2C%20artistic%20minimal%20composition%2C%20editorial%20photography&width=800&height=600&seq=cat-society-01&orientation=landscape",
  },
];

export const categoryMap: Record<string, (typeof categories)[number]> = categories.reduce(
  (acc, item) => {
    acc[item.slug] = item;
    return acc;
  },
  {} as Record<string, (typeof categories)[number]>
);